import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { MoonIcon, SunIcon } from "ui/gluestack/icon";
import { CloudSunIcon } from "ui/gluestack/icon/CloudSun";
import { CupIcon } from "ui/gluestack/icon/CupIcon";
import { CupIntake1 } from "ui/gluestack/icon/CupIntake1";
import { CupIntake2 } from "ui/gluestack/icon/CupIntake2";
import { CupIntake3 } from "ui/gluestack/icon/CupIntake3";
import { FileIcon } from "ui/gluestack/icon/File";
import { FileSearch } from "ui/gluestack/icon/FileSearch";
import { SunsetIcon } from "ui/gluestack/icon/Sunset";
import { IntestineIcon } from "ui/gluestack/icon/IntestineIcon";
import { BodyMapIcon } from "ui/gluestack/icon/BodyMapIcon";

export const REPORT_TYPE_MAP = [
  { icon: FileIcon, tag: FormEnums.DAILY_REPORTING, label: "Daily Reporting" },
  {
    icon: FileSearch,
    tag: FormEnums.RESIDENT_STATE_REPORTING,
    label: "Resident State Reporting",
  },
  {
    icon: BodyMapIcon,
    tag: FormEnums.RESIDENT_BODY_MAP,
    label: "Resident Body Map",
  },
  {
    icon: CupIcon,
    tag: FormEnums.FLUID_INTAKE_OUTPUT_REPORT,
    label: "Fluid Intake and Output Report",
  },
  {
    icon: IntestineIcon,
    tag: FormEnums.BOWEL_MOVEMENT,
    label: "Bowel Movement",
  },
];

export const iconMapping = {
  "Morning Routine": CloudSunIcon,
  "Midday Routine": SunIcon,
  "Evening Routine": SunsetIcon,
  "Night Routine": MoonIcon,
};

export const FLUID_INTAKE__MAP = [
  { icon: CupIntake1, label: "~ 60ml", value: 60 },
  { icon: CupIntake2, label: "~ 125ml", value: 125 },
  { icon: CupIntake3, label: "~ 250ml", value: 250 },
];
